import { setCookie, getCookie, clearCookie } from "utils/function-utils";
import { GraphqlApi } from 'services/api';
import { ACCESSIBLE_PAGES, DEFAULT_ROUTES, ROLES } from "constants/userConstants";

export const rolesMap = Object.keys(ROLES).reduce((acc, key) => {
    const role = ROLES[key];
    acc[role] = {
        defaultRoute: DEFAULT_ROUTES[role],
        accessible: ACCESSIBLE_PAGES[role]
    };
    return acc;
}, {});

export const rerouteCachedPath = (auth, navigate, location) => {
    const isPathLogin = location === '/' || location === '/login';

    if (!auth && !isPathLogin) {
        setCookie('rememberRedirect', location);
        return false;
    }

    const pathCookie = getCookie('rememberRedirect');
    if (auth && pathCookie) {
        if (!pathCookie) return false;

        const { pathname } = JSON.parse(pathCookie);
        const page = pathname.split('/')[1];
        if (page && (auth.role === 'admin' || rolesMap[auth.role]?.accessible.includes(page))) {
           // clearCookie('rememberRedirect');
            navigate(pathname);
            return true;
        }
        return false;
    }

    return false;
}

export const rerouteFromRoot = (user, navigate, search='') => {
    if (search) {
        const route = search.split("=")[1];
        navigate(route);
        return;
    }

    if (user) {
        console.log('rerouteFromRoot', user);
        clearCookie('rememberRedirect');
        const path = rolesMap[user.role || user.ocplcRole]?.defaultRoute || '/dashboard';
        navigate(path);
        return;
    }
}

export const useRerouteRole = () => {
    return async (userRole) => {
        const path = rolesMap[userRole]?.defaultRoute || '/dashboard';
        await GraphqlApi.query("switchRole", {
            roleID: userRole
          });
        window.location.pathname = path;
    }
}

export const useReroute = (navigate) => {

    return (userRole) => {
       const resetPathCookie= getCookie('rememberRedirect');    
        const path = resetPathCookie ? JSON.parse(resetPathCookie).pathname :  rolesMap[userRole]?.defaultRoute || '/dashboard';
        navigate(path);
    }
}

export const isRoleSelected = (roleId, userDetails) => 
  [userDetails?.role, userDetails?.ocplcRole].includes(roleId);
